import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import MainLayout from './components/MainLayout';
import Home from './components/Home/Home';
import Products from './components/Products/Products';
import Partners from './components/Partners/Partners';
import NewsEvents from './components/NewsEvents/NewsEvents';
import AboutUS from './components/AboutUs/AboutUS';
import ContactUs from './components/Contact Us/ContactUs';
import MyAccount from './components/MyAccount/MyAccount';
import ProductDetails from './components/ProductDetails/ProductDetails';
import NewsEventDetails from './components/NewsEvents/NewsEventDetails';
import Dashboard from './components/Dashboard/Dashboard';
import MyOrders from './components/Dashboard/MyOrders/MyOrders';
import AccountDetails from './components/Dashboard/AccountDetails/AccountDetails';
import Seller from './components/Dashboard/Seller/Seller';
import Buyers from './components/Dashboard/Buyers/Buyers';
import ManageCategory from './components/Dashboard/Category/ManageCategory';
import HomeSlide from './components/Dashboard/HomeSlide/HomeSlide';
import ManageNewsEvents from './components/Dashboard/NewsEvents/ManageNewsEvents';
import ManageProducts from './components/Dashboard/AddProducts/ManageProducts';
import OrderDetails from './components/Dashboard/MyOrders/OrderDetails';
import PartnerInfo from './components/Partners/PartnerInfo';
import PartnersDetails from './components/Dashboard/PartnersDetails/PartnersDetails';
import Address from './components/Dashboard/Address/Address.js';
import { PaymentFailure, PaymentSuccess } from './components/PaymentUI/PaymentUI.js';
import PrivacyPolicy from './components/Policies/PrivacyPolicy.js';
import ReturnAndRefundPolicy from './components/Policies/ReturnAndRefundPolicy.js';
const RouteConfig = () => {
  return (
    // <Router>
    <Routes>
      <Route
        path='/'
        element={<MainLayout />}
      >
        <Route
          index
          element={<Home />}
        />
        <Route
          path='/products'
          element={<Products />}
        />
        <Route
          path='/clients'
          element={<Partners />}
        />
        {/* <Route path='/newsevents' element={<NewsEvents />} /> */}
        <Route
          path='/aboutus'
          element={<AboutUS />}
        />
        <Route
          path='/contactus'
          element={<ContactUs />}
        />
        <Route
          path='/account'
          element={<MyAccount />}
        />
           <Route
        path='/privacy-policy'
        element={<PrivacyPolicy />}
      />
      <Route
        path='/return-and-refund-policy'
        element={<ReturnAndRefundPolicy />}
      />
        <Route
          path='/productDetails/:id'
          element={<ProductDetails />}
        />
        <Route
          path='/partnerInfo/:id'
          element={<PartnerInfo />}
        />
        {/* <Route path='/newsEventDetails' element={<NewsEventDetails />} /> */}
        <Route
          path='/myAccount/dashboard'
          element={<Dashboard />}
        />
        <Route
          path='/myAccount/addproducts'
          element={<ManageProducts />}
        />
        <Route
          path='/myAccount/addcategory'
          element={<ManageCategory />}
        />
        <Route
          path='/myAccount/seller'
          element={<Seller />}
        />
        <Route
          path='/myAccount/buyers'
          element={<Buyers />}
        />
        <Route
          path='/myAccount/homeSlide'
          element={<HomeSlide />}
        />
        <Route
          path='/myAccount/clientsDetails'
          element={<PartnersDetails />}
        />
        {/* <Route path='/myAccount/newsevents' element={<ManageNewsEvents />} /> */}
        <Route
          path='/myAccount/orders'
          element={<MyOrders />}
        />
        <Route
          path='/myAccount/orders/orderDetails/:user_id/:seller_id'
          element={<OrderDetails />}
        />
        <Route
          path='/myAccount/accountDetails'
          element={<AccountDetails />}
        />
        <Route
          path='/myAccount/address'
          element={<Address />}
        />
      </Route>
      <Route
        path='/payment/success'
        element={<PaymentSuccess />}
      />
       <Route
        path='/payment/failure'
        element={<PaymentFailure />}
      />
    
    </Routes>
    // </Router>
  );
};

export default RouteConfig;
